/**
 * Change that occured and triggered the refresh step.
 * 
 * @export
 * @class Changes
 */
export class Changes {

}